import { useState } from 'react'
import { searchStateData } from '../../data/searchStateData';
import { useAppDispatch } from '../../redux/hooks'
import { searchDataUpdated, toggleAppShowFilterMenu } from '../../redux/reducers/searchSlice'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector'
import '../../style/explore/style-app-explore-menus.scss'
import AppRangeSliderRange from '../app_rangeSliderRange/AppRangeSliderRange';
import AppRangeSliderBasic from '../app_rangeSliderBasic/AppRangeSliderBasic';
import IconText from '../iconText/IconText';

function AppSearchFilterMenu() {
	const [selectedGenderOptions, setSelectedGenderOptions] = useState<number[]>(searchStateData.subFilterOptions[1].value !== undefined ? searchStateData.subFilterOptions[1].value as number[] : [])
	const [languageValue, setLanguageValue] = useState<number | undefined>(searchStateData.subFilterOptions[0].value !== undefined ? searchStateData.subFilterOptions[0].value as number : undefined)
	const [priceRangeValue, setPriceRangeValue] = useState<number[] | undefined>(searchStateData.subFilterOptions[5].value !== undefined ? searchStateData.subFilterOptions[5].value as number[] : undefined)
	const [selectedRationOptions, setSelectedRationOptions] = useState<number[]>(searchStateData.subFilterOptions[2].value !== undefined ? searchStateData.subFilterOptions[2].value as number[] : [])
	const [ageRangeValue, setAgeRangeValue] = useState<number[] | undefined>(searchStateData.subFilterOptions[3].value !== undefined ? searchStateData.subFilterOptions[3].value as number[] : undefined)

	const dispatch = useAppDispatch()

	const closeButtonClickHandler = () => {
		dispatch(toggleAppShowFilterMenu())
	}

	const languageSelectHandler = (newValue: number) => {
		if (searchStateData.subFilterOptions[0].value === newValue) {
			searchStateData.subFilterOptions[0].value = undefined
		} else {
			searchStateData.subFilterOptions[0].value = newValue
		}
		setLanguageValue(searchStateData.subFilterOptions[0].value)
	}
	const priceRangeChangeHandler = (newValue: number[] | undefined) => {
		searchStateData.subFilterOptions[5].value = newValue
		setPriceRangeValue(newValue)
	}
	const genderSelectHandler = (genderIndex: number) => {
		let reformedArr: number[] = [...selectedGenderOptions]
		if (reformedArr.includes(genderIndex)) {
			reformedArr.splice(reformedArr.indexOf(genderIndex), 1)
		} else {
			reformedArr.push(genderIndex)
		}
		setSelectedGenderOptions(reformedArr.length > 0 ? reformedArr : [])
		searchStateData.subFilterOptions[1].value = reformedArr.length > 0 ? reformedArr : undefined
	}
	const ratingSelectHandler = (ratingIndex: number) => {
		let reformedArr: number[] = [...selectedRationOptions]
		if (reformedArr.includes(ratingIndex)) {
			reformedArr.splice(reformedArr.indexOf(ratingIndex), 1)
		} else {
			reformedArr.push(ratingIndex)
		}
		setSelectedRationOptions(reformedArr.length > 0 ? reformedArr : [])
		searchStateData.subFilterOptions[2].value = reformedArr.length > 0 ? reformedArr : undefined
	}
	const ageRangeChangeHandler = (newValue: number[] | undefined) => {
		searchStateData.subFilterOptions[3].value = newValue
		setAgeRangeValue(newValue)
	}

	const clearSearchButtonClickHandler = () => {
		// searchStateData.clearExistingProfiles()
		searchStateData.clearAllSubFilterOptions()
		setSelectedGenderOptions([])
		setLanguageValue(undefined)
		setPriceRangeValue(undefined)
		// instructorSearchConnector.performSearchRequest().then((successRequest) => {
		// 	dispatch(searchDataUpdated())
		// 	if (!successRequest) {
		// 		console.log('WARNING - [App] - performSearchRequest() failed')
		// 	}
		// })
	}
	const quickSearchButtonClickHandler = () => {
		searchStateData.clearExistingProfiles()
		instructorSearchConnector.performSearchRequest().then((successRequest) => {
			dispatch(searchDataUpdated())
			closeButtonClickHandler()
			if (!successRequest) {
				console.log('WARNING - [App] - performSearchRequest() failed')
			}
		})
	}

	return (
		<div className='app-quick-search-background'>
			<div className={`app-quick-search-wrap`}>
				<div className='app-quick-search-title'>Filters</div>
				<img
					className='app-quick-search-close'
					src='/imgs/icons/explore/icon-x.svg'
					alt='close'
					onClick={() => {
						closeButtonClickHandler()
					}}
				/>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Language</div>
					<select 
						className='app-quick-search-menu-item-select'
						value={languageValue ? languageValue : ''}
						onChange={(event) => {
							languageSelectHandler(parseInt(event.target.value) as number)
						}}
					>
						<option value="" disabled>Language...</option>
						{searchStateData.subFilterOptions[0].valueLabels.map((valueLabel: string, index: number) => 
							<option 
								value={index as number}
								key={`languageOption${index}`}
							>{valueLabel}</option>
						)}
					</select>
					<img
						className='app-quick-search-menu-item-arrow'
						src='/imgs/icons/explore/icon-menu-arrow.svg'
						alt='arrow'
					/>
				</div>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Price Range</div>
					<AppRangeSliderRange
						// valueLabels={['$0', '$80+']}
						// value={[0,3]}
						value={priceRangeValue}
						stepCounts={[0,0,0,0,0,0,0,0,0,3,5,6,7,10,9,12,20,21,23,16,15,12,14,9,10,13,13,12,17,14,13,8,6,3,0,1,4,2,0,1]}
						stepCount={40}
						minValue={0}
						maxValue={80}
						onValueUpdate={(newValue: number[] | undefined) => {
							// console.log(selectedValues)
							// console.log(newValue)
							// levelValueChangeHandler(newValue)
							priceRangeChangeHandler(newValue)
						}}
					/>
				</div>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Gender</div>
					<div className='app-quick-search-menu-item-button-wrap'>
						{searchStateData.subFilterOptions[1].valueLabels.map((option: string, index: number) => 
							<button 
								className={`app-quick-search-menu-item-button ${selectedGenderOptions.includes(index) ? 'selected' : ''}`}
								onClick={() => {
									genderSelectHandler(index)
								}}
								key={`genderButtons${index}`}
							>{option}</button>
						)}
					</div>
				</div>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Age</div>
					<AppRangeSliderBasic
						valueLabels={searchStateData.subFilterOptions[3].valueLabels}
						value={ageRangeValue}
						onValueUpdate={(newValue: number[] | undefined) => {
							ageRangeChangeHandler(newValue)
						}}
					/>
				</div>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Rating</div>
					<div className='app-quick-search-menu-item-button-wrap'>
						{searchStateData.subFilterOptions[2].valueLabels.map((option: string, index: number) => 
							<button 
								className={`app-quick-search-menu-item-button ${selectedRationOptions.includes(index) ? 'selected' : ''}`}
								onClick={() => {
									ratingSelectHandler(index)
								}}
								key={`ratingButtons${index}`}
							><IconText text={option} /></button>
						)}
					</div>
				</div>
				<div className='app-quick-search-bottom-wrap'>
					<div className='app-quick-search-bottom-gradient' />
					<button 
						className={'app-quick-search-bottom-button-white'}
						onClick={(event) => { 
							event.stopPropagation()
							clearSearchButtonClickHandler()
						}}
					>
						<div className='app-quick-search-bottom-button-label'>Clear all</div>
					</button>
					<button 
						className={'app-quick-search-bottom-button-blue'}
						onClick={(event) => { 
							event.stopPropagation()
							quickSearchButtonClickHandler()
						}}
					>
						<div className='app-quick-search-bottom-button-label'>Show Instructors</div>
					</button>
				</div>
			</div>
		</div>
	)
}

export default AppSearchFilterMenu
